<app-hero-pannel></app-hero-pannel>
<app-product-category></app-product-category>
<app-usp-section></app-usp-section>
<!-- <app-product-comparison></app-product-comparison> -->
<app-solutions></app-solutions>
<!-- <app-case-studies></app-case-studies> -->
<!-- <app-impact></app-impact>
<app-products></app-products>
<app-ifp></app-ifp>
<app-aip></app-aip> -->
<app-client-logo-slider></app-client-logo-slider>
<app-testimonial></app-testimonial>